<template>
    <div class="container" v-bind:value.sync="valor">
        <div class="row">
            <div class="col-12 p0">
                <div class="overflow-auto" style="height: 500px">
                    <b-list-group>
                        <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in filtrado" :key="item.id" :active="item.id===elejido.id" v-on:click="seleccionado(item)">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="d-flex w-100 justify-content-between">
                                        <h6><b>{{item.empresa}} {{item.nombre}}</b></h6>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <small>{{item.canton}}</small>
                                </div>
                                <div class="col-md-3">
                                    <small>{{item.detalles}}</small>
                                </div>
                                <div class="col-md-2">
                                    <small>{{item.itemal ? "C.P. "+item.itemal :  null}}</small>
                                </div>
                            </div>
                        </b-list-group-item>
                        <div class="d-flex w-100 justify-content-between text-danger" v-if="cargando">
                            <h6 class="mb-1">Cargando</h6>
                        </div>
                        <div v-else>
                            <div class="d-flex w-100 justify-content-between text-danger" v-if="filtrado.length===0">
                                <h6 class="mb-1">No existen resultados</h6>
                            </div>
                        </div>
                    </b-list-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import constantes from "@/constantes";
    import * as servicio from "@/servicios";
    export default {
        name: "kia-mapa",
        data:()=>({
            valor:{},
            configuracionMap:{
                mapTypeControl:false,
                mapTypeControlOptions:false,
                streetViewControl:false,
                styles:constantes.Constantes.mapaEstilos
            },
            actual:{lng:null,lat:null},
            ver:false,
            lista:[],
            elejido:{
                centro:{lat:parseFloat(process.env.VUE_APP_PAIS_LAT), lng:parseFloat(process.env.VUE_APP_PAIS_LNG)},
                acercamiento:7,
                id:null,
            },
            cargando:true,

        }),
        props: ['value','filtro'],
        computed:{
            filtrado: function() {
                if (this.filtro === null)
                    return this.lista;
                let vm = this;
                return vm.lista.filter( (item)=> item.nombre.toLowerCase().indexOf(vm.filtro.toLowerCase()) !== -1 || item.canton.toLowerCase().indexOf(vm.filtro.toLowerCase()) !== -1 || item.parroquia.toLowerCase().indexOf(vm.filtro.toLowerCase()) !== -1 || item.empresa.toLowerCase().indexOf(vm.filtro.toLowerCase()) !== -1 || item.detalles.toLowerCase().indexOf(vm.filtro.toLowerCase()) !== -1);
            }
        },
        methods:{
            /**
             * cambia de formato de hora
             * **/
            shora:function(valor){
                return this.$moment(valor, "HH:mm:ss").format("HH[h]mm");
            },
            /**
             * consulta al backend la lista de consecionarios
             * y serializa la informacion para el depliegue
             * **/
            consultar:function(){
                this.cargando=true;
                servicio.concesionarios.agencias().then((response)=>{
                    let vm=this;
                    response.data.map(function(item){
                        if(item.elements[0].dt15){
                            let dias=[];
                            if(item.dt5){
                                let vector=item.dt5.split(",");
                                vector.map(function(item2){
                                    dias.push(
                                        {
                                            dia:item2.split(" ")[0],
                                            horas:(item2.split(" ")[1]).split("-"),
                                        }
                                    )
                                });
                            }
                            vm.lista.push({
                                id:item.id,
                                empresa:item.dt4,
                                nombre:item.dt1,
                                direccion:item.elements[0].dt2,
                                detalles:item.elements[0].dt2+' '+item.elements[0].dt4+' '+item.elements[0].dt3,
                                tipo:item.elements[0].dt6,
                                pais:item.elements[0].dt7,
                                prov:item.elements[0].dt8,
                                canton:item.elements[0].dt10,
                                parroquia:item.elements[0].dt9 ? item.elements[0].dt9 : "",
                                barrio:item.elements[0].dt11,
                                itemal:item.elements[0].dt13,
                                horas:4,//item.dt6.split("-"),
                                dias:dias,
                                // distancia:vm.calcularDistancia({lng:parseFloat(item.elements[0].dt15),lat:parseFloat(item.elements[0].dt14)}),
                                centro:{lat:parseFloat(item.elements[0].dt14), lng:parseFloat(item.elements[0].dt15)},
                                acercamiento:16,
                                lng:parseFloat(item.elements[0].dt15),
                                lat:parseFloat(item.elements[0].dt14),
                                ver:false,
                                original:item,
                            });
                        }
                    });
                    this.cargando=false;
                });
            },
            /**
             *  //todo funcion que calcula la distancia desde la poscicion del usuario
             *  hasta la del punto
             * **/
            calcularDistancia:function(punto){
                let google = window.google;
                let puntoA = new google.maps.LatLng(this.actual.lat, this.actual.lng);
                let puntoB = new google.maps.LatLng(punto.lat, punto.lng);
                return google.maps.geometry.spherical.computeDistanceBetween(puntoA, puntoB);
            },
            /**
             * Consulta la poscicion actual del usuario
             * **/
            poseActual:function(){
                let vm=this;
                navigator.geolocation.getCurrentPosition(
                    function(position) {
                        vm.actual={lat:position.coords.latitude,lng:position.coords.longitude};
                    },
                    function() {
                        //no soporta el navegador
                    }
                );
            },
            seleccionado:function(elemento){
                this.valor=elemento;
                this.$emit('input', elemento);
                this.elejido.acercamiento=16;
                this.ocultarInfos();
                elemento.ver=true;
                this.elejido=elemento;
                this.elejido.acercamiento=16;
            },
            ocultarInfos:function(){
                this.lista.map(function(item){
                    item.ver=false;
                });
            }
        },
        created(){
            this.ocultarInfos();
            this.consultar();
        },
        mounted() {
            if(this.value)
                this.seleccionado(this.value);

        }
    }
</script>

<style scoped>
    .mapa{
        width: 100%;
        height: 500px;
    }
    .col-md-3,.col-md-9,.col-md-6{
        padding: 0px;
    }
    .p0{
        padding: 0px;
    }
    .overflow-auto::-webkit-scrollbar {
        width: 1em;
    }
    .overflow-auto::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }
    .overflow-auto::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        outline: 1px solid slategrey;
    }
</style>
